var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{ref:_vm.getAudioRef(),attrs:{"id":_vm.id}},[_c('source',{attrs:{"src":_vm.url,"type":"audio/mpeg"}}),_vm._v("\n        "+_vm._s(_vm.errorAudio)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }